import { render, staticRenderFns } from "./FormControlMBasketOrdersLogs.vue?vue&type=template&id=0a8a3ffc"
import script from "./FormControlMBasketOrdersLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMBasketOrdersLogs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports